export function buildStep(element, title, description, side="bottom", align="start") {
  return { element, popover: { title, description, side, align } };
}